<!-- <div class="container-fluid m-0 p-0 bg-primary mb-0" *ngIf="DISPLAY_ENV_BAR" >
  <h6 class="text-white text-center p-2">Este proyecto esta corriendo en el entorno de: {{ENV_NAME}}</h6>
</div> -->
<div class="main-content-wrapper">
  <router-outlet></router-outlet>
</div>
